<div style="width: 100%;" class="expansion-panel w-full rounded-2xl bg-primary-600/70 text-white user-card min-w-full">
    <!-- Header -->
    <div style="width: 100%;" class="expansion-header flex justify-between w-full items-center p-2 cursor-pointer" (click)="togglePanel()">
        <ng-content select="[expansion-header]"></ng-content>

        <!-- Toggle Icon with Rotation Animation -->
        <div class="p-2 transition-transform duration-300" [ngClass]="{'rotate-180': isOpen, 'rotate-180 3': !isOpen}">
            <svg *ngIf="!isOpen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>

            <svg *ngIf="isOpen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
            </svg>
        </div>
    </div>

    <!-- Content -->
    <div *ngIf="isOpen" class="expansion-body bg-primary-800/35 user-card p-2 rounded-xl" @slideDownUp>
        <ng-content select="[expansion-content]"></ng-content>
    </div>
</div>
